<template>
   <el-dialog title="条码维护" :visible.sync="dialogVisible" width="500px" append-to-body @opened="handleOpened" @close="handleClose" @keydown="handleDialogKeyDown">
      <!-- 商品信息展示 -->
      <div v-if="selectedCartItem" class="product-info-section">
         <div class="section-title">当前选中商品</div>
         <div class="product-info-card">
              <div class="product-row">
               <span class="label">商品编码：</span>
               <span class="value">{{ selectedCartItem.bgmCode }}</span>
            </div>
            <div class="product-row">
               <span class="label">商品名称：</span>
               <span class="value">{{ selectedCartItem.bgmName }}</span>
            </div>
            <div class="product-row">
               <span class="label">商品规格：</span>
               <span class="value">{{ selectedCartItem.spec || '无' }}</span>
            </div>
            <div class="product-row">
               <span class="label">当前条码：</span>
               <span class="value current-barcode">{{ selectedCartItem.barcode || '无' }}</span>
            </div>
            <div class="product-row">
               <span class="label">批号：</span>
               <span class="value">{{ selectedCartItem.sterBatchno || '无' }}</span>
            </div>
         </div>
      </div>

      <!-- 条码维护表单 -->
      <div class="barcode-form-section">
         <el-form ref="barcodeFormRef" :model="form" :rules="rules" label-width="100px" size="small" >
            <el-form-item label="新条码" prop="barcode">
               <el-input ref="barcodeInput" v-model="form.barcode" placeholder="请输入新的条码" clearable @keydown.native="handleInputKeyDown">
               </el-input>
            </el-form-item>

         </el-form>
      </div>

      <!-- 操作提示 -->
      <div class="tips-section">
         <el-alert title="操作提示" type="info" :closable="false" show-icon>
            <div slot="default">
               <p>• 请确保新条码的准确性，条码更新后将影响商品识别</p>
               <p>• 支持扫描枪直接扫描条码到输入框</p>
               <p>• 按 Enter 键确认，按 Esc 键取消</p>
            </div>
         </el-alert>
      </div>

      <!-- 底部按钮 -->
      <span slot="footer" class="dialog-footer">
         <el-button type="primary" @click="handleConfirm" :loading="confirmLoading">
            确认更新
         </el-button>
      </span>
   </el-dialog>
</template>

<script>
export default {
   name: 'BarcodeMaintenanceDialog',
   props: {
      visible: {
         type: Boolean,
         default: false
      },
      // 当前选中的购物车商品
      selectedCartItem: {
         type: Object,
         default: () => null
      }
   },
   data() {
      return {
         // 表单数据
         form: {
            barcode: '',


         },

         // 确认按钮加载状态
         confirmLoading: false
      };
   },
   computed: {
      dialogVisible: {
         get() {
            return this.visible;
         },
         set(value) {
            this.$emit('update:visible', value);
         }
      },

      // 表单验证规则
      rules() {
         return {
            barcode: [
               { required: true, message: '请输入新条码', trigger: 'blur' },
               { min: 3, max: 50, message: '条码长度应在3-50个字符之间', trigger: 'blur' },
               {
                  validator: (rule, value, callback) => {
                     if (value && this.selectedCartItem && value === this.selectedCartItem.bgmCode) {
                        callback(new Error('新条码不能与当前条码相同'));
                     } else {
                        callback();
                     }
                  },
                  trigger: 'blur'
               }
            ],

         };
      }
   },
   watch: {
      visible(newVal) {
         if (newVal) {
            this.initForm();
         } else {
            this.resetForm();
         }
      },

      selectedCartItem: {
         handler(newItem) {
            if (newItem && this.visible) {
               this.initForm();
            }
         },
         immediate: true
      }
   },
   methods: {
      // 初始化表单
      initForm() {
         this.form = {
            barcode: '',


         };

         // 清除表单验证
         this.$nextTick(() => {
            if (this.$refs.barcodeFormRef) {
               this.$refs.barcodeFormRef.clearValidate();
            }
         });
      },

      // 重置表单
      resetForm() {
         this.form = {
            barcode: '',


         };
         this.confirmLoading = false;
      },

      // 弹窗打开事件
      handleOpened() {
         // 聚焦到条码输入框
         this.$nextTick(() => {
            if (this.$refs.barcodeInput) {
               this.$refs.barcodeInput.focus();
            }
         });

         this.$emit('opened');
      },

      // 弹窗关闭事件
      handleClose() {
         this.dialogVisible = false;
         this.$emit('close');
      },

      // 键盘事件处理
      handleDialogKeyDown(event) {
         if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.handleClose();
         } else if (event.key === 'Enter' ) {
            event.preventDefault();
            event.stopPropagation();
            this.handleConfirm();
         }
      },

      // 输入框键盘事件处理
      handleInputKeyDown(event) {
         if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.handleConfirm();
         } else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.handleClose();
         }
         // 其他键不做任何处理，让输入框正常工作
      },

      // 确认更新条码
      async handleConfirm() {
         if (!this.selectedCartItem) {
            this.$message.warning('请先选择要维护的商品');
            return;
         }

         // 表单验证
         try {
            await this.$refs.barcodeFormRef.validate();
         } catch (error) {
            return;
         }

         this.confirmLoading = true;

         try {
            // 调用条码更新API
            const response = await this.$http.retailChangeBarCode({
               bgmId: this.selectedCartItem.bgmId,
               barcode: this.form.barcode,
            });

            if (response.status === 200) {
               this.$message.success('条码更新成功');
               // 发出确认事件，传递更新后的条码信息
               this.$emit('confirm', {
                  cartItem: this.selectedCartItem,
                  barcode: this.form.barcode,
              
               });

               this.handleClose();
            } else {
               this.$message.error('条码更新失败：' + (response.message || '未知错误'));
            }
         } catch (error) {
            console.error('条码更新失败:', error);
            this.$message.error('条码更新失败：' + (error.message || '网络错误'));
         } finally {
            this.confirmLoading = false;
         }
      },
   }
};
</script>

<style scoped>
.product-info-section {
   margin-bottom: 20px;
}

.barcode-form-section {
   margin-bottom: 20px;
}

.tips-section {
   margin-bottom: 20px;
}

.section-title {
   font-size: 14px;
   font-weight: bold;
   color: #303133;
   margin-bottom: 10px;
   padding-bottom: 5px;
   border-bottom: 1px solid #e4e7ed;
}

.product-info-card {
   background: #f8f9fa;
   border: 1px solid #e9ecef;
   border-radius: 4px;
   padding: 15px;
}

.product-row {
   display: flex;
   margin-bottom: 8px;
   align-items: center;
}

.product-row:last-child {
   margin-bottom: 0;
}

.label {
   font-weight: 500;
   color: #606266;
   min-width: 80px;
   flex-shrink: 0;
}

.value {
   color: #303133;
   flex: 1;
}

.current-barcode {
   font-family: "Courier New", monospace;
   background: #fff;
   padding: 2px 6px;
   border: 1px solid #dcdfe6;
   border-radius: 3px;
   font-weight: bold;
   color: #409eff;
}

/* 表单样式优化 */
::v-deep .el-form-item__label {
   color: #606266 !important;
   font-weight: 500;
}

::v-deep .el-input__inner {
   border-radius: 4px;
}

::v-deep .el-textarea__inner {
   border-radius: 4px;
}

/* 提示框样式 */
::v-deep .el-alert__content {
   padding-left: 8px;
}

::v-deep .el-alert__content p {
   margin: 2px 0;
   font-size: 13px;
   line-height: 1.4;
}

/* 按钮样式 */
.dialog-footer {
   text-align: right;
}

.dialog-footer .el-button {
   margin-left: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
   .product-row {
      flex-direction: column;
      align-items: flex-start;
   }

   .label {
      margin-bottom: 4px;
   }
}
</style>
